/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  DeleteVariantMutationResponse,
  DeleteVariantPathParams,
  DeleteVariant400,
  DeleteVariant404,
} from '../types/DeleteVariant'

function getDeleteVariantUrl({ id }: { id: DeleteVariantPathParams['id'] }) {
  const res = {
    method: 'DELETE',
    url: `/api/v1/products/catalog/variants/${id}/` as const,
  }
  return res
}

/**
 * @description Soft delete a variant.
 * DELETE /variants/{pk}/
 * Args:
 * request: The request object
 * pk: Variant ID
 * Returns:
 * Response with success message or error
 * @summary Delete a variant
 * {@link /api/v1/products/catalog/variants/:id/}
 */
export async function deleteVariant(
  { id }: { id: DeleteVariantPathParams['id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    DeleteVariantMutationResponse,
    ResponseErrorConfig<DeleteVariant400 | DeleteVariant404>,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteVariantUrl({ id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
